export default {
  getOrderInfo: '/gateway/capp/mallcenter/PropSaleForAppRpcService/getOrderDetail'
}
